import useLenis from "@/hooks/useLenis";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import BrandMarquee from "@/components/site/BrandMarquee";
import Services from "@/components/site/Services";
import Fleet from "@/components/site/Fleet";
import Manifesto from "@/components/site/Manifesto";
import Partners from "@/components/site/Partners";
import TrackWidget from "@/components/site/TrackWidget";
import QuoteSection from "@/components/site/QuoteSection";
import Footer from "@/components/site/Footer";

export default function Home() {
  useLenis();
  const scrollToQuote = () =>
    document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="grain bg-ink">
      <Navbar />
      <Hero onQuote={scrollToQuote} />
      <BrandMarquee />
      <Services onQuote={scrollToQuote} />
      <Fleet />
      <Manifesto />
      <Partners onQuote={scrollToQuote} />
      <TrackWidget />
      <QuoteSection />
      <Footer />
    </div>
  );
}
